let galleryMain;
let galleryThumbs;

/* OPEN GALLERY */
function openProductGallery(index){

  if(window.innerWidth <= 749){
return; // mobile pe modal disable
}

  const modal = document.getElementById("custom-product-gallery");

  modal.classList.add("active");

  document.body.style.overflow = "hidden";

  if(!galleryMain){
   
    galleryMain = new Swiper(".gallery-main",{
      spaceBetween:10,
      speed:600,
      navigation:{
        nextEl:".swiper-button-next",
        prevEl:".swiper-button-prev"
      },
      pagination:{
      el:".swiper-pagination",
       clickable:true
  }
    });
  }

galleryMain.slideTo(index, 0);
}




/* CLOSE GALLERY */
document.addEventListener("click",function(e){

 if(e.target.classList.contains("gallery-close")){

  document.getElementById("custom-product-gallery").classList.remove("active");

  document.body.style.overflow = "";

  // ✅ reset swiper to first slide
  if (galleryMain) {
    galleryMain.slideTo(0, 0);
  }

}

});


document.getElementById("custom-product-gallery").addEventListener("click", function(e){

  const isImageArea = e.target.closest(".image-section-full");
  const isNext = e.target.closest(".swiper-button-next");
  const isPrev = e.target.closest(".swiper-button-prev");
  const isClose = e.target.closest(".swiper-pagination");

  // in sab pe close nahi hoga
  if (isImageArea || isNext || isPrev || isClose) return;

  // close popup
  this.classList.remove("active");

  document.body.style.overflow = "";

  // ✅ reset swiper
  if (galleryMain) {
    galleryMain.slideTo(0, 0);
  }

});


/* OPEN CURRENT ACTIVE IMAGE IN POPUP */
document.addEventListener("click", function (e) {

    // ✅ mobile disable
  if (window.innerWidth <= 749) {
    return;
  }

  const clickedSlide = e.target.closest("slideshow-slide");
  if (!clickedSlide) return;

  const productGrid = clickedSlide.closest(".product-information__grid");
  if (!productGrid) return;

  // ✅ current visible slide
  const activeSlide = productGrid.querySelector(
    'slideshow-slide[aria-hidden="false"]'
  );

  if (!activeSlide) return;

  // ✅ current active image
  const activeImg = activeSlide.querySelector("img");

  if (!activeImg) return;

  const activeSrc = activeImg.getAttribute("src");

  // ✅ open popup
  const modal = document.getElementById("custom-product-gallery");

  modal.classList.add("active");

  document.body.style.overflow = "hidden";

  // ✅ init swiper
  if(!galleryMain){

    galleryMain = new Swiper(".gallery-main",{
      spaceBetween:10,
      speed:600,
      navigation:{
        nextEl:".swiper-button-next",
        prevEl:".swiper-button-prev"
      },
      pagination:{
        el:".swiper-pagination",
        clickable:true
      }
    });

  }

 
  // ✅ wait popup render
 

    // current popup active image
    const popupActiveImg = document.querySelector(
      '#custom-product-gallery .swiper-slide-active img'
    );

    if (!popupActiveImg) return;

const index = clickedSlide.dataset.galleryIndex;

if (document.querySelector('.variant-option--swatches')) {

  popupActiveImg.src = activeSrc;

} else {

  openProductGallery(parseInt(index));

}

  

});







/* CLOSE ON ESC KEY */
document.addEventListener("keydown", function (e) {

  if (e.key === "Escape") {

    const modal = document.getElementById("custom-product-gallery");

    if (modal.classList.contains("active")) {

      modal.classList.remove("active");

      document.body.style.overflow = "";

      // ✅ reset swiper
      if (galleryMain) {
        galleryMain.slideTo(0, 0);
      }

    }

  }

});

document.querySelectorAll(".zoom-container").forEach(container => {

  const img = container.querySelector("img");

  container.addEventListener("mousemove", (e) => {

    const rect = container.getBoundingClientRect();

    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    img.style.transformOrigin = `${x}% ${y}%`;
    img.style.transform = "scale(2)";

  });

  container.addEventListener("mouseleave", () => {
    img.style.transform = "scale(1)";
    img.style.transformOrigin = "center";
  });

});